import useTranslate from "@app/_hooks/useTranslate";
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionItem,
  AccordionTrigger,
} from "@ui/accordion";
import { Dialog, DialogTrigger } from "@ui/dialog";
import { Paragraph } from "@ui/paragraph";
import type { IN_STOCK_ITEM, StockStatusProps } from "../Stock.types";
import { stockStatusVariants } from "../Stock.utils";
import StockIndicator from "./StockIndicator";

export default function InStockItem({
  status,
  config,
}: {
  status: IN_STOCK_ITEM;
  config: StockStatusProps;
}) {
  const t = useTranslate();
  const { type, item, className, stockInfo } = config;

  const {
    root: rootSlot,
    trigger: triggerSlot,
    explanation: explanationSlot,
  } = stockStatusVariants({ type });

  if (type === "pdp") {
    return (
      <Dialog>
        <Accordion type="single" collapsible>
          <AccordionItem value={item?.key ?? "1"}>
            <AccordionHeader asChild>
              <div className={rootSlot()}>
                <StockIndicator status={status.code} />
                <span className="inline-block">
                  {t("inStockXPiecesLeft")?.replace(
                    "{quantity}",
                    status.pretty,
                  )}
                  {" ‒ "}
                  {t("shipsWithinDays")?.replace("{quantity}", "1-3")}
                </span>
                {status.quantity === Infinity ? (
                  <DialogTrigger className={triggerSlot({ kind: "dialog" })}>
                    {t("readMore")}
                  </DialogTrigger>
                ) : (
                  <AccordionTrigger
                    className={triggerSlot({ kind: "accordion" })}
                  >
                    {t("moreInfo")}
                  </AccordionTrigger>
                )}
              </div>
            </AccordionHeader>
            <AccordionContent>
              <Paragraph className={explanationSlot()}>
                {t("stockItemExplanation")?.replace(
                  "{date}",
                  status?.date ?? new Date().getFullYear().toString(),
                )}{" "}
                {stockInfo && (
                  <DialogTrigger className={triggerSlot({ kind: "dialog" })}>
                    {t("readMore")}
                  </DialogTrigger>
                )}
              </Paragraph>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
        {stockInfo}
      </Dialog>
    );
  }

  return (
    <div className={rootSlot({ className })}>
      <StockIndicator status={status.code} />
      <span className="inline-block">{t("inStock")}</span>
    </div>
  );
}
